import React from "react";
import { PageLayout } from "@Local/Components/Layout/";
import { Grid } from "@mui/material";
import {
	MemberAcquisitionSourceChart,
	CycleCalciumOrders,
	CycleProbioticsOrders,
	CycleProteinOrders,
	MemberAgeDistribution,
	MemberAgeInClub,
	MemberCheckInHeatmap,
	MembershipExpireTime,
	NewMemberAgeDistribution,
	NewMemberCalciumOrders,
	NewMemberProbioticsOrders,
	NewMemberProteinOrders,
	NewMemberSource,
	NewWorkoutFrequencyPrediction,
	PausedMemberAge,
	PauseReasons,
	QuitMemberAgeDistribution,
	QuitMemberTenure,
	QuitReasons,
	TotalWorkoutCountDistribution,
	WorkoutFrequencyLevel,
	YearlyAverageSpend,
	YearlyPurchaseCount,
	YearlyTotalSpend,
} from "@Local/Dashboard/Member/";
import * as echarts from "echarts/core";
import { BarChart, PieChart, HeatmapChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, TitleComponent, DatasetComponent, GraphicComponent, VisualMapComponent } from "echarts/components";
import { CanvasRenderer } from "echarts/renderers";

echarts.use([BarChart, PieChart, HeatmapChart, DatasetComponent, GridComponent, TitleComponent, TooltipComponent, LegendComponent, CanvasRenderer, GraphicComponent, VisualMapComponent]);

export const DASHBOARD_CHART_HEIGHT = {
	S: 220, // Compact
	M: 340, // Standard
	L: 440, // Tall
};

const MemberPage = props => {
	return (
		<PageLayout>
			<PageLayout.Header title="會員輪廓頁" />
			<Grid container spacing={1}>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員管道來源 */}
					<MemberAcquisitionSourceChart />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員年齡分佈 */}
					<MemberAgeDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會員年資 */}
					<MemberAgeInClub />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 會籍到期時間 */}
					<MembershipExpireTime />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 運動頻率分級 */}
					<WorkoutFrequencyLevel />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.L} item xs={12} md={6}>
					{/* 累計運動次數分布 */}
					<TotalWorkoutCountDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12}>
					{/* 入場時間分佈熱點 */}
					<MemberCheckInHeatmap />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環蛋白訂購狀況 */}
					<CycleProteinOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環益生菌訂購狀況 */}
					<CycleProbioticsOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 循環鈣力嗨訂購狀況 */}
					<CycleCalciumOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 年度平均客單價 */}
                    <YearlyAverageSpend />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 年度消費次數 */}
                    <YearlyPurchaseCount />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 年度消費金額 */}
                    <YearlyTotalSpend />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 新會員來源 */}
                    <NewMemberSource />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 新會員年齡分佈 */}
                    <NewMemberAgeDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 運動頻率預測 */}
                    <NewWorkoutFrequencyPrediction />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 新會員蛋白訂購狀況 */}
                    <NewMemberProteinOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 新會員益生菌訂購狀況 */}
                    <NewMemberProbioticsOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={4}>
					{/* 新會員鈣力嗨訂購狀況 */}
                    <NewMemberCalciumOrders />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					{/* 暫停會員年齡層分布 */}
                    <PausedMemberAge />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					{/* 主要暫停原因統計 */}
                    <PauseReasons />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					{/* 退會年齡層占比 */}
                    <QuitMemberAgeDistribution />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					{/* 退會會員年資分布 */}
                    <QuitMemberTenure />
				</Grid>
				<Grid height={DASHBOARD_CHART_HEIGHT.M} item xs={12} md={6}>
					{/* 主要退會原因分析 */}
                    <QuitReasons />
				</Grid>
			</Grid>
		</PageLayout>
	);
};

export default MemberPage;
